import React, { useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';
import VehicleTypeDetailModal from './VehicleTypeDetailModal';

const VehicleTypeChart = ({ data = [], loading = false, dateRange }) => {
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const COLORS = ['#3b82f6', '#10b981'];

  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const handlePieClick = (data) => {
    if (data && data?.type) {
      setSelectedVehicleType(data);
    }
  };

  const handleCardClick = (item) => {
    setSelectedVehicleType(item);
  };

  return (
    <>
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <div className="flex items-center gap-2">
            <Icon name="Car" size={24} className="text-success" />
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              Ingresos por Tipo de Vehículo
            </h2>
          </div>
          <p className="text-xs text-muted-foreground">
            Click para ver desglose de servicios
          </p>
        </div>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
        ) : data?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-64">
            <Icon name="CarOff" size={48} className="text-muted-foreground mb-2" />
            <p className="text-sm caption text-muted-foreground">
              No hay datos de vehículos disponibles
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ type, percent }) => `${type}: ${(percent * 100)?.toFixed(0)}%`}
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="totalRevenue"
                  onClick={handlePieClick}
                  cursor="pointer"
                >
                  {data?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => formatCurrency(value)} />
              </PieChart>
            </ResponsiveContainer>

            <div className="space-y-4">
              {data?.map((item, index) => (
                <div 
                  key={item?.type} 
                  className="bg-muted/50 rounded-lg p-4 cursor-pointer hover:bg-muted/70 transition-colors"
                  onClick={() => handleCardClick(item)}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <div 
                      className="w-4 h-4 rounded-full" 
                      style={{ backgroundColor: COLORS?.[index % COLORS?.length] }}
                    />
                    <h3 className="font-semibold text-foreground">{item?.type}</h3>
                    <Icon name="ChevronRight" size={16} className="text-muted-foreground ml-auto" />
                  </div>
                  <div className="space-y-1 text-sm">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Ingresos Totales:</span>
                      <span className="font-medium text-foreground">
                        {formatCurrency(item?.totalRevenue)}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Órdenes Completadas:</span>
                      <span className="font-medium text-foreground">{item?.count}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Ticket Promedio:</span>
                      <span className="font-medium text-foreground">
                        {formatCurrency(item?.averageTicket)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {selectedVehicleType && (
        <VehicleTypeDetailModal
          vehicleType={selectedVehicleType}
          dateRange={dateRange}
          onClose={() => setSelectedVehicleType(null)}
        />
      )}
    </>
  );
};

export default VehicleTypeChart;